import { useCallback, useMemo, useState } from "react";
import { ILocalStorageSnapshot } from "../types";
import {
  setLocalStorageItem,
  getLocalStorageItem,
} from "../utils/localStorageHelper";
const useSnapshotHistory = () => {
  const [snapshotHistory, setSnapshotHistory] = useState<
    ILocalStorageSnapshot[]
  >([]);

  const storeSnapshotHistory = useCallback(
    (account: string, snapshotId: string, chainId: number) => {
      const storeData = {
        account,
        snapshotId,
        timestamp: Date.now(),
        chainId,
      };

      const localStorageItem = getLocalStorageItem("user-snapshot") || [];
      if (localStorageItem) {
        const newData = [...localStorageItem, storeData];
        return setLocalStorageItem("user-snapshot", newData);
      }

      setLocalStorageItem("user-snapshot", [storeData]);
    },
    []
  );

  const removeSingleSnapshot = useCallback((snapshotId: string) => {
    const localStorageItem: {
      account: string;
      chainId: number;
      snapshotId: string;
      timestamp: number;
    }[] = getLocalStorageItem("user-snapshot") || [];
    if (localStorageItem) {
      // location snapshot entry by Id
      const index = localStorageItem.findIndex(
        (item) => item.snapshotId === snapshotId
      );

      // remove snapshot entry
      if (index > -1) {
        const newData = [
          ...localStorageItem.slice(0, index),
          ...localStorageItem.slice(index + 1),
        ];
        setLocalStorageItem("user-snapshot", newData);
      }
    }
  }, []);

  useMemo(() => {
    const localStorageItem = getLocalStorageItem("user-snapshot") || [];
    if (localStorageItem) {
      setSnapshotHistory(localStorageItem);
    }
  }, []);

  return { snapshotHistory, storeSnapshotHistory, removeSingleSnapshot };
};

export default useSnapshotHistory;
